import { AxiosResponse } from 'axios'

import { isErrorData } from '@/utils/errors'

export class UnauthenticatedError extends Error {}
export class ServerFailureError extends Error {}
export class BadRequestError extends Error {}
export class BackendAPIError extends Error {}
export class NoResponseError extends Error {}

export function isErrorResponse(response: AxiosResponse): boolean {
  return response.data.error && isErrorData(response.data.error)
}
